import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider, Grid } from '@mui/material';
import { useCheckoutFlow } from 'components/context/checkout_flow';
import ReceiptItem from 'components/common/receipt/receipt_item';
import { orderSummaryStyles } from 'components/pages/checkout/order_summary';
import { subtitleStrings } from 'utilities/financing_strings';
import { includedTaxCalculation } from 'utilities/tax';

const InstallmentReceipt = () => {
  const classes = orderSummaryStyles();
  const { t } = useTranslation();
  const { orderData } = useCheckoutFlow();

  const summary = orderData.installment_summary;

  if (Object.entries(summary).length === 0) {
    return null;
  }

  const n = summary.number_payment_periods;
  const totalOwedAmount = summary.total_owed_amount;

  return (
    <>
      <Grid className={classes.orderSummary}>
        <ReceiptItem
          label="checkout.receipt.label.installmentPlanTotal"
          cost={totalOwedAmount.amount}
          currency={totalOwedAmount.currency_code}
          emphasize
        />
        <Divider sx={{ my: 1 }} />
        <div>
          <p className="semibold-20">
            {t('checkout.receipt.label.nPayments', { n })}
          </p>
        </div>
        {subtitleStrings(summary).map((s, idx) => (
          <Fragment key={`offer-subtitle-${idx}`}>
            <div className="paragraph-20">{s}</div>
          </Fragment>
        ))}
      </Grid>
      <Grid className={classes.orderSummary}>
        <h3>{t('checkout.receipt.label.hardwarePaidToday')}</h3>
        <ReceiptItem
          label="checkout.receipt.label.deposit"
          cost={orderData.installment_summary.final_payment_amount.amount}
          currency={
            orderData.installment_summary.final_payment_amount.currency_code
          }
        />
        {orderData.shipping.amount > 0 && (
          <ReceiptItem
            label={orderData.shipping.label}
            cost={orderData.shipping.amount}
            currency={orderData.shipping.currency}
            isShipping={true}
          />
        )}
        {/* Instead of a TaxReceiptItem, we need to "construct" the GST amount to include the portion from the deposit */}
        <ReceiptItem
          label={orderData.included_tax.label}
          cost={includedTaxCalculation(
            orderData.payment_due.amount,
            0.1,
          ).tax.toUnit()}
          currency={orderData.included_tax.currency}
          isTax={true}
        />
        <Divider sx={{ my: 1 }} />
        <ReceiptItem
          label="checkout.receipt.label.dueToday"
          cost={orderData.payment_due.amount}
          currency={orderData.payment_due.currency}
          emphasize
        />
      </Grid>
    </>
  );
};

export default InstallmentReceipt;
